import { createLogger } from '@practium/features/logging';

const authLogger = createLogger({
	prefix: 'AUTH',
	level: 'info',
	environment: process.env.NODE_ENV as 'development' | 'production' | 'test',
});

export const authLog = {
	logRegistration: (userId: string, email: string): void => {
		authLogger.info('User registration completed', {
			userId,
			email,
			timestamp: new Date().toISOString(),
			ipAddress: 'mock_ip',
			userAgent: navigator.userAgent,
		});
	},

	logLogin: (userId: string, email: string, rememberMe: boolean): void => {
		authLogger.info('User login successful', {
			userId,
			email,
			timestamp: new Date().toISOString(),
			rememberMe,
		});
	},

	logLogout: (userId: string): void => {
		authLogger.info('User logout', {
			userId,
			timestamp: new Date().toISOString(),
		});
	},

	logError: (operation: string, error: string): void => {
		authLogger.error(`Authentication error: ${operation}`, {
			operation,
			error,
			timestamp: new Date().toISOString(),
		});
	},

	logValidationError: (field: string, error: string): void => {
		authLogger.warn('Validation failed', {
			field,
			error,
			timestamp: new Date().toISOString(),
		});
	},

	logSessionRefresh: (userId: string): void => {
		authLogger.debug('Session refreshed', {
			userId,
			timestamp: new Date().toISOString(),
		});
	},
};
